import { gql } from '../../../../../hooks'

export const READ_BRANDS = gql`
  query AdministrationReadMachineBrands($id: ID!) {
    aRead(path: "machine/brands", id: $id) {
    }
  }
`

export const UPDATE_BRANDS = gql`
  mutation AdministrationUpdateMachineBrands($id: ID!, $data: JSONObject) {
    aUpdate(path: "machine/brands", id: $id, data: $data) {
    }
  }
`

export const CREATE_BRANDS = gql`
  mutation AdministrationCreateMachineBrands($data: JSONObject) {
    aCreate(path: "machine/brands", data: $data) {
    }
  }
`

export const LIST_BRANDS = gql`
  query AdministrationListMachineBrands(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(path: "machine/brands", filter: $filter, page: $page, limit: $limit) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
